<template>
  <div class="area-setting-header">
    <instruction-icon></instruction-icon>
    <div class="aisea-text-16-400-black">
      {{ text }}
    </div>
  </div>
</template>

<script>
import InstructionIcon from "./InstructionIcon.vue";
export default {
  name: "AreaSettingHeader",
  components: {
    InstructionIcon,
  },
  props: {
    text: {
      type: String,
      default: "マウスをドラッグして範囲を指定してください(最大：12nm x 12nm)",
    },
  },
};
</script>

<style lang="scss" scoped>
.area-setting-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
